module.exports = __webpack_public_path__ + "img/filipe-palhoca-vinhos.e6eb715c.jpg";